import React, { FC, ReactNode } from 'react';
import { toast } from 'react-toastify';
import { ImProfile } from 'react-icons/im';
import { MdFileDownload } from 'react-icons/md';

import Button from 'components/styled/Button';
import Text from 'components/styled/Text';
import { Flex } from 'components/styled';
import Divider from 'components/styled/Divider';

import { generateAllCVofCandidates } from 'api/studentApi';

import ModalDialog, { ModalDialogDefaultBody } from '.';

import { OfferDto } from 'typing/endpoints';

type Props = {
	offerId: string;
	control: (openModal: () => void) => ReactNode;
} & Partial<Pick<OfferDto, 'cvOfStudents'>>;

const OfferDownloadCVDialog: FC<Props> = ({
	control,
	offerId,
	cvOfStudents,
}) => {
	return (
		<ModalDialog control={openModal => <>{control(openModal)}</>} label="asd">
			{closeModal => (
				<ModalDialogDefaultBody
					closeModal={closeModal}
					title="Stáhnout CV všech zájemců"
				>
					<Flex alignItems="center" flexDirection="column">
						<Flex
							my={4}
							flexDirection="column"
							maxWidth="410px"
							alignItems="center"
						>
							<Button
								onClick={async () => {
									try {
										const resp = await generateAllCVofCandidates(offerId);
										if (resp.ok) {
											toast.success(
												'Požadavek na stáhnutí CV zájemců vytvořen. Po dokončení budete upozorněni notifikací.',
											);
											closeModal();
										} else {
											toast.error(
												'Požadavek na stáhnutí CV zájemců se nepodařilo vytvořit. Zkuste to prosím později.',
											);
											closeModal();
										}
									} catch (error) {
										toast.error(
											'Požadavek na stáhnutí CV zájemců se nepodařilo vytvořit. Zkuste to prosím později.',
										);
										closeModal();
									}
								}}
							>
								<ImProfile size={15} color="white" />
								<Text as="span" ml={2}>
									Vytvořit požadavek na stáhnutí CV všech zájemců
								</Text>
							</Button>
							<Text>CV budou připraveny za 2-3 minuty</Text>
							<Divider size={1} mt={4} mb={1} borderColor="#dddddd" />
							<Text textAlign="center">
								{cvOfStudents?.created ? (
									<>
										Naposledy vygenerované:{' '}
										<b>
											{new Date(cvOfStudents?.created).toLocaleDateString('cs')}
											{' | '}
											{new Date(cvOfStudents?.created).toLocaleTimeString('cs')}
										</b>
									</>
								) : (
									<Text as="span">
										Dosud nebyl zadán nebo dokončen žádný požadavek na
										vygenerování životopisů.
									</Text>
								)}
							</Text>
							<Button
								variant="primary"
								disabled={!cvOfStudents?.id}
								onClick={() => window.open(`/api/files/${cvOfStudents?.id}`)}
							>
								<MdFileDownload size={16} color="white" />
								<Text as="span" ml={2}>
									Stáhnout vygenerované CV
								</Text>
							</Button>
						</Flex>
					</Flex>
				</ModalDialogDefaultBody>
			)}
		</ModalDialog>
	);
};

export default OfferDownloadCVDialog;
